<template>
    <div class="container"  v-title="'培训详情'">
        <Navigation-bar title="培训详情">
            <YD-image src="icon/icon_nav_分享" class="share" v-share="shareConfig"></YD-image>
        </Navigation-bar>
        <div class="container_content">
            <div id="Training_detail" ref="Training_detail" v-show="pageShow">
                <Scroll
                    :scroll.sync="scrollTop"
                >
                    <div class="TD_content">
                        <div class="tab" v-scrollShadow="tabScrollShadow">
                            <ul>
                                <li v-for="(item,index) in tabs" :key="index"
                                    :class="{'active':tabId == item.Id}"
                                    @click="selectTab(item.Id)"><span>{{item.Name}}</span></li>
                            </ul>
                        </div>
                        <div class="tab_content" :class="{'enroll': isEnroll}" >
                            <ul>
                                <li v-for="(item,index) in tabs" :key="index"
                                    :class="{'active': tabId == item.Id}"
                                >
                                    <template v-if="item.Id == 1">
                                        <Detail
                                            :trainData="trainDetail" 
                                            v-if="tabContents.includes(item.Id)"
                                            @lookImage="lookImage"
                                        ></Detail>
                                    </template>

                                    <template v-else-if="item.Id == 4">
                                        <Communique :channelId="item.channelId" :channelUrl="item.channelUrl" v-if="tabContents.includes(item.Id)"></Communique>
                                    </template>

                                    <template v-else-if="item.Id == 3">
                                        <Examine-result :trainId="trainId" :channelId="item.channelId" :channelUrl="item.channelUrl"
                                            :trainEnd="item.TrainEnd" v-if="tabContents.includes(item.Id)"></Examine-result>
                                    </template>

                                    <template v-else-if="item.Id == 5">
                                        <Moments :channelId="item.channelId" :channelUrl="item.channelUrl"
                                            :isCurrentShow="item.Id == tabId" :scrollTop="scrollTop"
                                            v-if="tabContents.includes(item.Id)"
                                            @lookImage="lookImage"></Moments>
                                    </template>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Scroll>
            </div>
        </div>
        <div id="Enroll_operation" v-if="isEnroll">
            <button @click="openEnrollModel()">我要报名</button>
        </div> 
        <ImagePreview v-model="image.show" :images="image.list" :start-position="image.index" @change="image.index = $event" lazyLoad></ImagePreview>
        <YD-image src="icon/icon_保存" class="save_image" v-show="image.show" @click.native="saveImage"></YD-image>       
    </div>
</template>
<script>
import { ImagePreview } from 'vant';
import 'vant/lib/image-preview/style';

import hammerjs from 'hammerjs';
import Detail from './components/Detail.vue';//培训详情
import ExamineResult from './components/ExamineResult.vue'; //考核公示
import Communique from './components/Communique.vue'; //公告动态
import Moments from './components/Moments.vue'; //培训现场
import appInteraction from '@/common/appInteraction.js';
export default {
    name:"MatchDetail",
    components:{
        Detail,
        ExamineResult,
        Communique,
        Moments,
        ImagePreview: ImagePreview.Component
    },
    data(){
        let trainId = +this.$route.params.id
        return{
            trainId,
            pageShow: false,
            isShare: false,
            scrollTop: 0,
            trainDetail: {},
            tabs:[],
            tabId: 0,//tab
            tabContents: [],
            tabScrollObj: {},
            instrumentList: [],
            image:{
                list: [],
                index: 0,
                show: false
            }
        }
    },
    created(){
		this.getDetail();
    },
    mounted() {
        var _this = this;
        var mc = new hammerjs.Manager(this.$el,{
            threshold:100
        });
        var swipe = new hammerjs.Swipe();
        mc.add(swipe);
        mc.on('swiperight', function(e) {
            if(!_this.image.show){
                _this.$navigation.back();
            }
        });
    },
    computed:{
        shareConfig(){
            return {
                Type: 5,
                Title: ['报名即将开始', '火热报名中', '待开班', '培训中', ''][this.trainDetail.NowStatus - 1],
                Text: this.Description.Name,
                Link: 'https://m.dazhongyundong.com/app_download/',
                LinkText: '立即下载APP：',
                ImgLink: this.Description.TrainCover || 'https://file.dazhongyundong.com/static/train/train_cover_default.png'
            }
        },
        tabScrollShadow(){
            return [1,2].includes(this.tabId) && this.scrollTop;
        },
        Description: function() {
            return this.trainDetail.Description || {}
        },
        isEnroll(){
            return this.trainDetail.NowStatus == 2;
        },

    },
    methods:{
        getDetail() {
            this.$api.GetPublishTrainDetail({
					TrainId: this.trainId
				}).then(data => {
					if (data.Code == 0) {
						this.pageShow = true;
						this.trainDetail = data.TrainDetail;
						let tabs = [{
							Id: 1,
							Name: '培训详情'
						}];
						if (data.TrainDetail.SscmsCntsCountInfo && data.TrainDetail.SscmsCntsCountInfo.length > 0) {
							let channelList = data.TrainDetail.SscmsCntsCountInfo;
							let communiqueObj = null,
								examineResultObj = null,
								momentsObj = null;

							for (let i = 0, len = channelList.length; i < len; i++) {
								let {
									ChannelType,
									ChannelName: Name,
									ChannelId: channelId,
									Url: channelUrl
								} = channelList[i];
								switch (ChannelType) {
									case 'notice':
										communiqueObj = {
											Name,
											channelId,
											channelUrl
										};
										break;
									case 'progress':
										examineResultObj = {
											Name,
											channelId,
											channelUrl
										};
										break;
									case 'album':
										momentsObj = {
											Name,
											channelId,
											channelUrl
										};
										break;
								}
							}
							if (communiqueObj) {
								tabs.push({
									Id: 4,
									...communiqueObj
								})
							}
							if (examineResultObj || data.TrainDetail.NowStatus == 5) {
								let obj = {
									Id: 3,
									Name: examineResultObj ? examineResultObj.Name : '考核公示'
								}
								obj.TrainEnd = data.TrainDetail.NowStatus == 5;
								tabs.push({
									...obj,
									...(examineResultObj || {})
								})
							}
							if (momentsObj) {
								tabs.push({
									Id: 5,
									...momentsObj
								})
							}
						} else if (data.TrainDetail.NowStatus == 5) {
							tabs.push({
								Id: 3,
								Name: '考核公示',
								TrainEnd: true
							})
						}
						this.tabs = tabs;
						if(!this.tabId){
							this.selectTab(tabs[0].Id);
						}
						
					}
				});
        },
        selectTab(tabId){
            if(!this.tabContents.includes(tabId)){
                this.tabContents.push(tabId);
            }
            if(this.tabId != tabId){
				this.tabScrollObj[this.tabId] = this.scrollTop;
                this.scrollTop = this.tabScrollObj[tabId] || 0;
                this.tabId = tabId;
            }
        },
        openEnrollModel(){
            this.$Prompt({
                title: '培训报名',
                message: '点击“确定”将跳转到“亿动体育”小程序进行报名。',
                showCancel: true,
            }).then(confirm=>{
                if(confirm){
                    appInteraction.jumpWxMiniApp(`/pages/training/trainingDetail/trainingDetail?trainId=${this.trainId}`);
                }
            })
        },
        lookImage(imageObj){
            this.$set(this, 'image', imageObj);
        },
        saveImage(){
            let {
                list,
                index
            } = this.image;
            appInteraction.saveImage(list[index]);
        }
    }
}
</script>
<style lang="scss" scoped>
.tab{
    $w:100%;
    $h:80px;
    width: $w;
    height: $h;
    background: #FFFFFF;
    position: sticky;
    z-index: 3;
    top: 0;
    left: 0;
    ul{
        width: $w;
        height: $h;
        display: flex;
        padding: 0 40px;
        box-sizing: border-box;
        position: relative;
        &::after{
            content: '';
            width: 100%;
            border-bottom: 1px #E5E5E5 solid;
            position: absolute;
            bottom: 0;
            left: 0;
        }
        li{
            width: 20%;
            height: $h;
            text-align: center;
            white-space: nowrap;
            &:last-of-type{
                margin-right: 0;
            }
            span{
                display: inline-block;
                @include line-height($h);
                font-size: 28px;
                color: #666666;
                font-weight: 400;
            }
            &.active{
                span{
                    font-size: 32px;
                    color: #7AD21A;
                    font-weight: 500;
                    border-bottom: 2px #7AD21A solid;
                    box-sizing: border-box;
                }
            }
        }
    }
}
.tab_content{
    &.enroll{
        padding-bottom: 192px;
    }
    ul{
        width: 100%;
        height: auto;
        li{
            width: 100%;
            height: auto;
            display: none;
            &.active{
                display: block;
            }
        }
    }
}
#Enroll_operation{
    @include bottom-button;
}

.van-image-preview{
    ::v-deep .van-image-preview__index{
        font-size: 32px;
    }
}
.save_image{
    width: 96px;
    height: 96px;
    position: fixed;
    bottom: 100px;
    left: calc(50% - 48px);
    z-index: 4000;
}
</style>